import _ from 'lodash';
import OrderComplexProxy from '@/proxies/Order/OrderComplexProxy';
import OrderProxy from '@/proxies/Order/OrderProxy';
import Vue from 'vue';
import { deepMerge, strReplaceAll } from '@/utils';
import CloneModal from '@/components/listings/Orders/CloneModal.vue';

export default {
  data() {
    return {
      /* Modals */
      currentEditableItem: {},
      currentClonableItem: {},
      /* Delete */
      isShowDeleteDialog: false,
      /* Page management */
      pageLoading: false,
      /* Listing management */
      isTableLoading: false,
      cachedFullOrders: {},
    };
  },
  components: {
    CloneModal,
  },
  created() {
    this.isTableLoading = true;
  },
  computed: {
    orderDialogActionLabel() {
      if (this.isShowOrderDialog) {
        return (this.currentEditableItem.uuid)
          ? this.lang(this.$store, 'sap/listings.global.edit.save')
          : this.lang(this.$store, 'sap/listings.global.edit.create');
      }
      return '';
    },
    acceptModalText() {
      return strReplaceAll(this.lang(this.$store, 'sap/listings.global.delete.question'), {
        user: this.currentEditableItem.datetime,
      });
    },
  },
  methods: {
    getOrderProxy() {
      return new OrderComplexProxy();
    },
    onPaginatedItemDelete(item) {
      this.currentEditableItem = item;
      this.isShowDeleteDialog = true;
    },
    onPaginatedItemCopy(item) {
      if (_.isNil(this.cachedFullOrders[item.uuid])) {
        this.getOrderProxy()
          .find(item.uuid)
          .then((response) => {
            this.cachedFullOrders[item.uuid] = response.data.data.order;
            this.copyToClipboard(this.cachedFullOrders[item.uuid]);
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.copyToClipboard(this.cachedFullOrders[item.uuid]);
      }
    },
    onPaginatedItemEdit(item) {
      if (_.isNil(this.cachedFullOrders[item.uuid])) {
        this.getOrderProxy()
          .find(item.uuid)
          .then((response) => {
            this.cachedFullOrders[item.uuid] = response.data.data.order;
            this.currentEditableItem = this.cachedFullOrders[item.uuid];
            this.isShowOrderDialog = true;
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.currentEditableItem = this.cachedFullOrders[item.uuid];
        this.isShowOrderDialog = true;
      }
    },
    onAcceptDeletion() {
      this.isRequestingNow = true;
      this.getOrderProxy()
        .destroy(this.currentEditableItem.uuid)
        .catch((response) => {
          console.error(response);
          alert(`Error: ${response.status}`);
          this.isRequestingNow = false;
        })
        .then(() => {
          this.fetchData();
        });
    },
    onFilter(event) {
      const newSearchParams = Object.assign({}, event);
      this.searchParams = deepMerge(this.searchParams, deepMerge(newSearchParams, {
        page: {
          number: 1,
        },
      }));
    },
    onPreviewItem(item) {
      this.previewPopup.title = this.lang(this.$store, 'sap/listings.global.additional_info');
      this.previewPopup.content = item.contact.address_additional_info;
      Vue.set(this.previewPopup, 'show', true);
    },
    onPaginatedItemClone(item) {
      this.currentClonableItem = item;
    },
    onCloneModalClose() {
      Vue.nextTick(() => {
        this.currentClonableItem = {};
      });
    },
    onCloneModalAccept(datesList) {
      const { uuid } = this.currentClonableItem;
      const type = (this.currentClonableItem.order_complex_type) ? 'complex' : 'base';
      const dates = datesList.map(date => date.format('YYYY-MM-DD'));
      Vue.nextTick(() => {
        this.currentClonableItem = {};
      });
      if (dates.length > 0) {
        this.isTableLoading = true;
        new OrderProxy()
          .setParameter('dates', dates)
          .cloneOrder({
            uuid,
            type,
          })
          .then((response) => {
            this.fetchData();
          })
          .catch(() => {
            this.$store.dispatch('page/displaySnackbar', {
              text: 'Ошибка при клонировании заказа',
              color: 'red darken-3',
              timeout: 6000,
            });
          })
          .finally(() => {
            this.isTableLoading = false;
          });
      }
    },
  },
};
